import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/projects/page';

export const Route = createFileRoute('/_app/_chat/projects/')({
  component: Page,
});
